(function () {
  'use strict';

  var I18N = window.casifyI18n || {};

  // ── Mobile accordion ──────────────────────────────────────────────────────
  // Same JS height animation as the FAQ accordion (page.faq.liquid) — the
  // smoothest option here. The wrap is overflow:hidden; we animate its height
  // 0 ↔ scrollHeight and set it to auto once open so it adapts to content.
  document.querySelectorAll('.site-footer__col--accordion').forEach(function (col) {
    var header = col.querySelector('.site-footer__col-header');
    var wrap   = col.querySelector('.site-footer__accordion-wrap');
    if (!header || !wrap) return;

    // Start collapsed on mobile. Set height/overflow first (no transition), then
    // enable the transition next frame so the initial collapse is instant.
    if (window.innerWidth < 768) {
      wrap.style.height = '0px';
      wrap.setAttribute('inert', '');
      window.requestAnimationFrame(function () {
        wrap.style.transition = 'height 0.25s cubic-bezier(0.4, 0, 0.2, 1)';
      });
    } else {
      wrap.removeAttribute('inert');
    }

    function toggle() {
      if (window.innerWidth >= 768) return;
      var isOpen = col.classList.contains('is-open');

      if (isOpen) {
        // Snapshot current height (auto → px), then animate to 0
        wrap.style.height = wrap.scrollHeight + 'px';
        col.classList.remove('is-open');
        header.setAttribute('aria-expanded', 'false');
        wrap.setAttribute('inert', '');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            wrap.style.height = '0px';
          });
        });
      } else {
        col.classList.add('is-open');
        header.setAttribute('aria-expanded', 'true');
        wrap.removeAttribute('inert');
        wrap.style.height = wrap.scrollHeight + 'px';
        wrap.addEventListener('transitionend', function onEnd(e) {
          // Ignore bubbled transitions from children (e.g. link color); only
          // react to the wrap's own height transition finishing.
          if (e.target !== wrap || e.propertyName !== 'height') return;
          if (col.classList.contains('is-open')) wrap.style.height = 'auto';
          wrap.removeEventListener('transitionend', onEnd);
        });
      }
    }

    header.addEventListener('click', toggle);
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) {
        wrap.removeAttribute('inert');
        wrap.style.height = 'auto';
      } else if (!col.classList.contains('is-open')) {
        wrap.setAttribute('inert', '');
        wrap.style.height = '0px';
      }
    });
  });

  // ── Newsletter form → Klaviyo ─────────────────────────────────────────────
  var form  = document.getElementById('footer-newsletter-form');
  var msgEl = document.getElementById('footer-newsletter-msg');
  if (!form || !msgEl) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    var email     = form.querySelector('input[type="email"]').value.trim();
    if (!email) return;

    var btn       = form.querySelector('.site-footer__newsletter-btn');
    var publicKey = form.dataset.publicKey;
    var listId    = form.dataset.listId;

    btn.disabled    = true;
    btn.textContent = I18N.newsletterSubmitting || 'Bezig...';
    msgEl.textContent = '';
    msgEl.className   = 'site-footer__newsletter-msg';

    try {
      if (publicKey && listId) {
        var res = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + publicKey,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2023-12-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email: email } } },
                },
                relationships: { list: { data: { type: 'list', id: listId } } },
              },
            }),
          }
        );
        if (!res.ok && res.status !== 202) throw new Error('klaviyo_error');
      }
      msgEl.textContent = I18N.newsletterSuccess || 'Bedankt! Je kortingscode ontvang je zo in je mail.';
      msgEl.classList.add('site-footer__newsletter-msg--success');
      form.reset();
      document.dispatchEvent(new CustomEvent('footer:newsletter:success', { detail: { email: email } }));
    } catch (err) {
      msgEl.textContent = I18N.newsletterError || 'Er ging iets mis, probeer het opnieuw.';
      msgEl.classList.add('site-footer__newsletter-msg--error');
    } finally {
      btn.disabled    = false;
      btn.textContent = I18N.newsletterSubmit || 'Aanmelden';
    }
  });
})();
